import { DEFAULT_DATA, SUPPLEMENT, type StreakData } from './types';

const STORAGE_KEY = 'nn-streak-by-supplement';

type AllData = Record<string, StreakData>;

function loadAll(): AllData {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return parsed as AllData;
    }
  } catch {
    // corrupted — fall through
  }
  return {};
}

function saveAll(all: AllData): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function loadSupplement(supplement: string = SUPPLEMENT): StreakData {
  return { ...DEFAULT_DATA, ...(loadAll()[supplement] ?? {}) };
}

export function saveSupplement(data: StreakData, supplement: string = SUPPLEMENT): void {
  saveAll({ ...loadAll(), [supplement]: data });
}
